<!-- start projekt: npm run dev -->
<template>
  <div class="content">
    
    <h1>Vectoria & kampen mod tiden.</h1>

    <p class="bigger">Vectoria & kampen mod tiden 
er Coding Class Odenses fællesspil 2020.
Alle karakterer, objekter og baggrunde 
er lavet af 6. klasseselever fra en masse
forskellige folkeskoler i Odense, der alle har deltaget i Coding Class i løbet af skoleåret 19/20.</p>
 
<p class="bigger">Spillet handler om Vectoria der må rejse i 
tiden og bekæmpe dinosaurer, vikinger og 
aliens, for at redde verden.</p>
 
<p class="bigger">Man styrer på piletasterne, 
skyder på space og skifter pistol på A.</p>
 
<p class="bigger">Tryk på space for at fortsætte.</p>

<p class="bigger">Spillet er under udvikling.</p>

<p class="bigger">Se den fulde spilhistorie under spillet.</p>
 


    



<div class="embeds">
          <EmbedScratch id="405139695" title="Vectoria & kampen mod tiden" />
        </div>

      
<h1>Vectoria & kampen mod tiden</h1>
<p>Vectoria er vores hovedperson, og det er hende man skal styre igennem spillet.
Hun er 15 år gammel og drømmer om at blive programmør.
Hendes mission er at redde verden fra Katatonianerne, en ondsindet race af rumvæsener, der kan rejse i tiden.</p>

<p>Året er 2027 og verden er overtaget af katatonianerne.
Grundet et datalæk i 2025 har de nu kontrollen over alle mennesker vha. en chip i hjernen. De bedøver dem med reality-tv imens de bruger deres hjernekræft til at mine intergalaktisk kryptovaluta.
Det eneste håb for menneskeheden er vores heltinde Vectoria, hvis chip faldt ud pga. pladsmangel.</p>

<p>For at redde verden må Vectoria finde krypteringsnøglen
og deaktivere alle hjernechipsene, så menneskene kan få deres frie vilje tilbage.</p>

<p>Katatonianerne er dog nogle snedige væsener, så de har delt nøglen i 3 og gemt dem i hver deres tidsperiode.</p>

<p>For at samle nøglen må Vectoria besøge Juratiden, Vikingetiden og Fremtiden.</p>

<p>Spillet starter i tidsmaskinen.</p>

<p>Bane 1 <br>
JURATIDEN <br>
En solrig tirsdag eftermiddag, 167 millioner år før vor tid, lander Vectoria i en regnskov fyldt med dinosaurer. 
Vectoria skal bekæmpe de forhistoriske kæmpeøgler, springe over kløfter og undgå giftige planter for at få fat i første 
del af nøglen.</p>

<p>Bane 2 <br>
VIKINGETIDEN <br>
En kold novembermorgen i år 987 lander Vectoria midt i en rimfrostdækket vikingeby. Svend Tveskæg, søn af Harald Blåtand, er netop blevet konge af Danmark, og vogter anden del af krypteringsnøglen, som han tror er en slags magisk runesten. Mon vores heltinde kan finde vej gennem vikingeborgen og undgå kongens trofaste hær af livvagter?
</p>

<p>Bane 3 <br>
FREMTIDEN <br>
Året er 3017 og Vectoria lander midt i det, der engang var Odense Centrum, men som nu tilsyneladende er en øde, smadret spøgelsesby efter krigen mellem robotter og mennesker. Vectoria begiver sig mod det gamle rådhus, hvor tredje del af nøglen ligger. Men ud fra ruinerne kommer en flok tungt bevæbnede robotter lige imod hende.
</p>
<p>
Når Vectoria har besejret de forskellige udfordringer i hver tidsperiode
kommer hun endelig tilbage til år 2027 hvor hun skal samle krypteringsnøglen og redde verden.
</p>

<p>Når hun har samlet krypteringsnøglen og sat den i hovedcomputeren
har hun 30 sekunder til at udføre 3 kommandoer.</p>

<p>Hvis hun når det vågner alle menneskene fra deres hjernefængsel, missionen er fuldført, og verden er reddet!</p>

<p>..Men hvis hun ikke når det, bliver samtlige hjernechips fastlåst i et endeløst loop af reality-tv.
</p> 

<br>
<br>
<br>
<br>
<br>
   
     
           </div>
</template>

<script>
import EmbedScratch from '@/components/ScratchEmbed';
import EmbedYoutube from '@/components/YoutubeEmbed';
export default {
  name: 'Day1',
  components: {
    EmbedScratch,
    EmbedYoutube
  }
}
</script>


<script>
import EmbedScratch from '@/components/ScratchEmbed';
export default {
  name: 'Links',
  components: {
    EmbedScratch
  }
}
</script>

<style scoped>
  .embeds {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  .embeds .scratchEmbed {
    height: 720px;
    width: 960px;
  }
  p {text-align: left; }
</style>


// WEBPACK FOOTER //
// src/components/pages/playground.vue